<header class="app-study-header">
  <mat-toolbar class="toolbar" color="secondary">
    <a
      mat-button
      *ngFor="let navItem of navItems"
      class="nav-button"
      routerLinkActive="active"
      [routerLink]="navItem.path"
    >
      {{ navItem.name }}
    </a>

    <span class="spacer"></span>
    <mat-icon
      *ngIf="showInvalidMessage"
      class="invalid-warning"
      color="warn"
      fontIcon="warning"
      matTooltip="Asegurate de completar todos los campos y cumplir con las validaciones básicas del formulario"
    ></mat-icon>
    <app-button
      *ngIf="saveButtonVisible"
      [disabled]="saveButtonDisabled"
      [loading]="saveButtonLoading"
      (buttonClick)="save.emit()"
      color="secondary"
    >
      Guardar
    </app-button>
  </mat-toolbar>
</header>
